export default __webpack_public_path__ + "static/media/UIF_StarLogo_white.195343d9.png";